import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import { Stack, Typography, Divider } from "@mui/material";

import Navigation from "../components/Navigation.jsx";
import Charts from "../components/Charts.jsx";
import Fqdns from "../components/Fqdns.jsx";

export default function Main() {
  const { apexdomain } = useParams();
  const navigate = useNavigate();

  const links = [{ title: "Charts" }, { title: "FQDNs" }, { title: "Changes" }];
  const [link, set_link] = useState(links[0]);

  const [loading, set_loading] = useState(true);
  const [error, set_error] = useState();

  const [apex, set_apex] = useState();

  const sx = { wrapper: { width: 1200, height: 1, alignItems: "center" } };

  useEffect(() => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BE_URL}/apex`,
      data: { apex_name: apexdomain },
    })
      .then((res) => {
        set_apex(res.data.apex);
      })
      .catch((err) => set_error(err.response.data))
      .finally(() => set_loading(false));
  }, [apexdomain]);

  if (loading) return <Typography>loading...</Typography>;
  if (error) return <Typography>{error}</Typography>;
  return (
    <Stack sx={sx.wrapper} spacing={3}>
      <p>{JSON.stringify(apex)}</p>
      <Navigation link={link} set_link={set_link} links={links} />
      {link.title === "Charts" && <Charts apex_id={apex._id} />}
      {link.title === "FQDNs" && <Fqdns apex_id={apex._id} />}
      {link.title === "changes" && <>chnages</>}
    </Stack>
  );
}

function Changes({ changes }) {
  const sx = {
    wrapper: { width: 1, backgroundColor: "", border: "1px solid lightgrey" },
  };

  return (
    <Stack sx={sx.wrapper}>
      <Typography>Changes</Typography>
      <Divider flexItem />
    </Stack>
  );
}
